import React from 'react';
import {DeclineTaskDrawer} from 'features/draft-task-actions/ui/DeclineTaskDrawer';
import type {
	CreateReceiptController,
	EmploymentMismatchController,
	SignAcceptanceController,
	TaskForOrderActions,
} from '../model/types';
import {CreateReceiptDrawer} from './CreateReceiptDrawer';
import {EmploymentMismatchModal} from './EmploymentMismatchModal';
import {SignAcceptanceDrawer} from './SignAcceptanceDrawer';

export interface OrderActionDrawersProps {
	task: Pick<TaskForOrderActions, 'acceptanceUri' | 'acceptanceCertificateUri'>;
	signAcceptance: SignAcceptanceController;
	createReceipt: CreateReceiptController;
	employmentMismatch: EmploymentMismatchController;
	declineDrawer: {
		isOpen: boolean;
		step: 'confirm' | 'success';
		isDeclining: boolean;
		close: () => void;
		confirm: () => void;
		continueAfterSuccess: () => void;
	};
}

export function OrderActionDrawers({
	task,
	signAcceptance,
	createReceipt,
	declineDrawer,
	employmentMismatch,
}: OrderActionDrawersProps): React.ReactElement {
	return (
		<>
			<EmploymentMismatchModal isOpen={employmentMismatch.isOpen} onClose={employmentMismatch.close} />

			<CreateReceiptDrawer open={createReceipt.isOpen} taskId={createReceipt.taskId} onClose={createReceipt.close} />

			<SignAcceptanceDrawer
				open={signAcceptance.isOpen}
				onClose={signAcceptance.close}
				acceptanceUri={task.acceptanceUri}
				acceptanceCertificateUri={task.acceptanceCertificateUri}
				onOpenAcceptance={signAcceptance.openAcceptance}
				onSignAcceptance={signAcceptance.signAcceptance}
			/>

			<DeclineTaskDrawer
				open={declineDrawer.isOpen}
				step={declineDrawer.step}
				onClose={declineDrawer.close}
				onConfirm={declineDrawer.confirm}
				onContinue={declineDrawer.continueAfterSuccess}
				isLoading={declineDrawer.isDeclining}
			/>
		</>
	);
}
